<template>
  <b-modal id="bv-modal-patient-eligible" :title="title" :visible="visible" scrollable centered hideHeaderClose
    no-close-on-backdrop no-close-on-esc hide-footer size="lg">
    <div>
      <div v-html="sanitizedDescription"></div>
      <b-button-toolbar class="pt-4">
        <b-button-group>
          <b-button class="default-button" @click="$emit('ok')">{{ okButtonText }}</b-button>
        </b-button-group>
      </b-button-toolbar>
    </div>
  </b-modal>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    okButtonText: {
      type: String,
      required: true
    }
  },
  computed: {
    sanitizedDescription() {
      return DOMPurify.sanitize(marked(this.description))
    }
  }
}
</script>
